module.exports = __webpack_public_path__ + "img/muzejWK.239ada8f.png";